import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a656998"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator_wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "indicator_rec" })
], -1))
const _hoisted_3 = {
  key: 1,
  class: "login_container"
}
const _hoisted_4 = { class: "login_header" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 비밀번호 다시등록 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 로그인 ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "intro",
  src: "/assets/image/login_intro@3x.png"
}, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "login_body"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 엔젤리그 로그인을 위한")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 간편 비밀번호를 다시 등록하기 위해")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 본인인증을 진행합니다. ")
const _hoisted_14 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login_body deep_blue" }, [
  /*#__PURE__*/_createTextVNode(" 핸드폰 본인인증만으로"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 간편 회원가입 끝! ")
], -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 신규회원은 첫 투자 지원금 ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 10,000P + 50,000P 적립 💰 ")
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 2,
  class: "login_container"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login_header" }, " 본인 인증 진행 중 ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "intro",
  src: "/assets/image/login_intro@3x.png"
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login_body" }, [
  /*#__PURE__*/_createTextVNode(" 본인 인증 후 이동 됩니다."),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_26 = [
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 3,
  class: "login_container"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login_header" }, " 본인 인증 실패 ", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "intro",
  src: "/assets/image/login_intro@3x.png"
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login_body" }, [
  /*#__PURE__*/_createTextVNode(" 다시 시도해 주세요."),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_31 = [
  _hoisted_28,
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = {
  key: 4,
  class: "login_container margin-top-30"
}
const _hoisted_33 = { class: "login_header" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/image/richie_orange.png",
  srcset: "/assets/image/richie_orange@2x.png 2x,/assets/image/richie_orange@3x.png 3x"
}, null, -1))
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = {
  key: 5,
  class: "account_container margin-top-30"
}
const _hoisted_37 = { class: "header" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 이메일 ", -1))
const _hoisted_40 = { class: "radio-container ion-text-left" }
const _hoisted_41 = ["value"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_43 = {
  key: 6,
  class: "agree_container"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/image/big_check.png",
  srcset: "/assets/image/big_check@2x.png 2x,/assets/image/big_check@3x.png 3x"
}, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 엔젤리그 서비스 이용약관 ", -1))
const _hoisted_46 = { class: "agreeAll" }
const _hoisted_47 = { class: "check-container" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" 약관에 모두 동의 ")
const _hoisted_50 = { class: "agree" }
const _hoisted_51 = { class: "check-container" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" 엔젤리그 ")
const _hoisted_54 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_55 = /*#__PURE__*/_createTextVNode(",")
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" 동의 (필수) ")
const _hoisted_58 = { class: "agree" }
const _hoisted_59 = { class: "check-container" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" 엔젤리그 소식, 신규 클럽딜 정보 수신 동의 (선택) ")
const _hoisted_62 = { class: "agree" }
const _hoisted_63 = { class: "check-container" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" 카카오클립 조합가입 증명카드 수신 동의. 개인정보 제 3자 제공 동의 (선택) ")
const _hoisted_66 = {
  key: 7,
  class: "login_container"
}
const _hoisted_67 = ["innerHTML"]
const _hoisted_68 = ["innerHTML"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "join_character",
  src: "/assets/image/join_character.png"
}, null, -1))
const _hoisted_70 = { class: "buttons" }
const _hoisted_71 = {
  key: 0,
  class: "inline_btn"
}
const _hoisted_72 = {
  key: 1,
  class: ""
}
const _hoisted_73 = {
  key: 2,
  class: ""
}
const _hoisted_74 = {
  key: 3,
  class: ""
}
const _hoisted_75 = {
  key: 4,
  class: ""
}
const _hoisted_76 = ["disabled"]
const _hoisted_77 = {
  key: 5,
  class: ""
}
const _hoisted_78 = ["disabled"]
const _hoisted_79 = {
  key: 6,
  class: ""
}
const _hoisted_80 = {
  key: 1,
  class: "wrapper"
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator_wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "indicator_rec" })
], -1))
const _hoisted_82 = {
  key: 1,
  class: "login_container"
}
const _hoisted_83 = /*#__PURE__*/_createStaticVNode("<div class=\"login_header\" data-v-0a656998> 로그인 </div><img class=\"intro\" src=\"/assets/image/login_intro@3x.png\" data-v-0a656998><div class=\"login_body\" data-v-0a656998><div class=\"not-allow\" data-v-0a656998> 로그인/회원가입 하시려면<br data-v-0a656998><img class=\"browser\" src=\"/assets/image/chrome.png\" srcset=\"/assets/image/chrome@2x.png 2x,/assets/image/chrome@3x.png 3x\" data-v-0a656998> 이나 <img class=\"browser\" src=\"/assets/image/safari.png\" srcset=\"/assets/image/safari@2x.png 2x,/assets/image/safari@3x.png 3x\" data-v-0a656998>를<br data-v-0a656998> 사용해주세요!<br data-v-0a656998></div> 카카오톡 브라우저로는<br data-v-0a656998> 엔젤리그를 원활히 사용하실 수 없어요 😥<br data-v-0a656998> ‘다른 브라우저로 열어서&#39; 사용 해주세요! </div>", 3)
const _hoisted_86 = [
  _hoisted_83
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_offline = _resolveComponent("offline")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!

  return (_ctx.validBrowser)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.processingStatus === 'internet-error')
          ? (_openBlock(), _createBlock(_component_offline, { key: 0 }))
          : (_ctx.processingStatus === 'init')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_ctx.resetPassword)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_5
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_6
                      ], 64))
                ]),
                _hoisted_7,
                (_ctx.resetPassword)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_14))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_15,
                      _createVNode(_component_ag_box_s, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ag_box_s, { css: {bg: '#E4F1FF', p: 8, mb: 4} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ag_box_s, { css: {color: 'gray2', typography: 'main14r'} }, {
                                default: _withCtx(() => [
                                  _hoisted_16
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ag_box_s, { css: {typography: 'mainL16r'} }, {
                                default: _withCtx(() => [
                                  _hoisted_17
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ag_box_s, { css: {bg: '#EEF1FF', p: 8} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ag_box_s, { css: {color: 'gray2', typography: 'main14r'} }, {
                                default: _withCtx(() => [
                                  (_ctx.inviteCode)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, " 지금 바로 회원가입 하면 "))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_19, " 비상장주식 판매시 "))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ag_box_s, { css: {typography: 'mainL16r'} }, {
                                default: _withCtx(() => [
                                  (_ctx.inviteCode)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.inviteCode) + "님 초대로 10,000P 적립 🎉 ", 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_21, " 수수료무료 + 10만P 적립 🎉 "))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 64))
              ]))
            : _createCommentVNode("", true),
        (_ctx.processingStatus === 'identityCertifying')
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_26))
          : _createCommentVNode("", true),
        (_ctx.processingStatus === 'identityCertifyFail')
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_31))
          : _createCommentVNode("", true),
        (_ctx.checkProcessStatus('under_adult'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.authInfoMessage.title), 1),
              _hoisted_34,
              _createElementVNode("div", {
                class: "login_body",
                innerHTML: _ctx.$filters.newLineToBr(_ctx.authInfoMessage.msg)
              }, null, 8, _hoisted_35)
            ]))
          : _createCommentVNode("", true),
        (_ctx.checkProcessStatus('duplicate_account'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.authInfoMessage.title), 1),
              _createElementVNode("div", {
                class: "body",
                innerHTML: _ctx.$filters.newLineToBr(_ctx.authInfoMessage.msg)
              }, null, 8, _hoisted_38),
              _hoisted_39,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.duplicateAccounts, (data, inx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: inx,
                  class: "select-account"
                }, [
                  _createElementVNode("label", _hoisted_40, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chooseAccount) = $event)),
                      type: "radio",
                      value: data.userId,
                      name: "chooseAccount"
                    }, null, 8, _hoisted_41), [
                      [_vModelRadio, _ctx.chooseAccount]
                    ]),
                    _hoisted_42,
                    _createTextVNode(" " + _toDisplayString(data.email), 1)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.checkProcessStatus('agree_need'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
              _hoisted_44,
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("label", _hoisted_47, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.agreeAll) = $event)),
                    type: "checkbox",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleAgreeAll && _ctx.toggleAgreeAll(...args)))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.agreeAll]
                  ]),
                  _hoisted_48,
                  _hoisted_49
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("label", _hoisted_51, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.agrees.agreeTerms) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.agrees.agreeTerms]
                  ]),
                  _hoisted_52,
                  _hoisted_53,
                  _createElementVNode("a", {
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.openLink('https://www.notion.so/angelleague/03d3a6fa9e0e41bb864d8289720bc52b')), ["prevent"]))
                  }, "이용약관"),
                  _hoisted_54,
                  _createElementVNode("a", {
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.openLink('https://www.notion.so/angelleague/cd4f32d98c4142f0858478c16de78c2f')), ["prevent"]))
                  }, "개인정보 처리방침"),
                  _hoisted_55,
                  _hoisted_56,
                  _createElementVNode("a", {
                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.openLink('https://www.notion.so/angelleague/64d5be41064142889063c53243bee0e2')), ["prevent"]))
                  }, "유료서비스 이용약관"),
                  _hoisted_57
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("label", _hoisted_59, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.agrees.agreeMarketing) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.agrees.agreeMarketing]
                  ]),
                  _hoisted_60,
                  _hoisted_61
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("label", _hoisted_63, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.agrees.agreeThirdparty) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.agrees.agreeThirdparty]
                  ]),
                  _hoisted_64,
                  _hoisted_65
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.checkProcessStatus('regist_success'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
              _createElementVNode("div", {
                class: "regist-success",
                innerHTML: _ctx.$filters.newLineToBr(_ctx.authInfoMessage.title)
              }, null, 8, _hoisted_67),
              _createElementVNode("div", {
                class: "regist-success-header",
                innerHTML: _ctx.$filters.newLineToBr(_ctx.authInfoMessage.msg)
              }, null, 8, _hoisted_68),
              _hoisted_69
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_70, [
          (_ctx.checkProcessStatus('init'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                _createElementVNode("button", {
                  class: "left_btn",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'로그인', 'clickContent':'회원가입', clickScreen: _ctx.clickScreen});_ctx.doStart()})
                }, " 회원가입 "),
                _createElementVNode("button", {
                  class: "right_btn",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'로그인', 'clickContent':'로그인하기', clickScreen: _ctx.clickScreen});_ctx.doStart()})
                }, " 로그인하기 ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.checkProcessStatus('identityCertifying'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                _createElementVNode("button", {
                  class: "block_btn",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'본인 인증 진행 중', 'clickContent':'인증 완료', clickScreen: _ctx.clickScreen});_ctx.doRefresh()})
                }, " 인증 완료 ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.checkProcessStatus('identityCertifyFail'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                _createElementVNode("button", {
                  class: "block_btn",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'본인 인증 실패', 'clickContent':'닫기', clickScreen: _ctx.clickScreen});_ctx.seeYa()})
                }, " 닫기 ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.checkProcessStatus('under_adult'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                _createElementVNode("button", {
                  class: "block_btn",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'미성년가 가입 불가', 'clickContent':'확인', clickScreen: _ctx.clickScreen});_ctx.seeYa()})
                }, " 확인 ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.checkProcessStatus('duplicate_account'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                _createElementVNode("button", {
                  disabled: !_ctx.chooseAccount,
                  class: "block_btn",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'이메일 선택', 'clickContent':'확인', clickScreen: _ctx.clickScreen});_ctx.onClickConfirmEmail()})
                }, " 확인 ", 8, _hoisted_76)
              ]))
            : _createCommentVNode("", true),
          (_ctx.checkProcessStatus('agree_need'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                _createElementVNode("button", {
                  disabled: !_ctx.agrees.agreeTerms,
                  class: "block_btn",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'약관동의', 'clickContent':'확인', clickScreen: _ctx.clickScreen});_ctx.onClickAgree()})
                }, " 확인 ", 8, _hoisted_78)
              ]))
            : _createCommentVNode("", true),
          (_ctx.checkProcessStatus('regist_success'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                _createElementVNode("button", {
                  class: "block_btn",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'본인인증 성공', 'clickContent':'확인', clickScreen: _ctx.clickScreen});_ctx.simplePassword()})
                }, " 확인 ")
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_80, [
        _hoisted_81,
        (_ctx.processingStatus === 'internet-error')
          ? (_openBlock(), _createBlock(_component_offline, { key: 0 }))
          : (_ctx.processingStatus === 'init')
            ? (_openBlock(), _createElementBlock("div", _hoisted_82, _hoisted_86))
            : _createCommentVNode("", true)
      ]))
}